<mat-form-field [appearance]  = "appearance" 
                class         = "w-100"
                id            = "file-container"
                (click)       = "openFileManager($event, fileInput)"
                floatLabel    = "always">
  <mat-label> {{ label | translate }}  </mat-label>

  <input      #fileInput
              type                = "file"
              [formControl]       = "formCtrl" 
              [multiple]          = "multiple"
              class               = "useless"
              (change)            = "fileSelectionChange( $event )"
              [disabled]          = "disabled"/>

  <input      #ctrlInput
              [formControl]       = "fileCtrl" 
              class               = "useless" 
              matInput />

  <div  class     =  "w-100 justify-content-between align-items-end"
        [ngClass] =   "showMissingImagePreview() ? 'd-block' : 'd-flex'">

    <div  *ngIf   = "showMissingImagePreview()"
          class   = "w-100 d-flex justify-content-end align-items-end">
          <cq-image-preview  class="w-100"   src    =   "assets/images/no_image.png"></cq-image-preview>
    </div>
    <button class       = "w-100"
            (click)     = "openFileManager($event, fileInput)"
            [matTooltip]= "addFileHelp | translate"
            *ngIf       = "!file"
            mat-stroked-button>
        {{ addFileLabel | translate }} 
        <mat-icon *ngIf = "addFileIcon | translate">
          {{ addFileIcon | translate }}
        </mat-icon>
    </button>

    <!-- File Preview -->
    <div  *ngIf   = "file && !fileCtrl?.errors"
          class   = "w-100 d-flex justify-content-end align-items-end">

      <cq-file-preview  class       =   "w-100"
                        [formCtrl]  =   "fileCtrl"></cq-file-preview>
    </div>


    <!-- Actions Section -->
    <div  class     = "d-flex h-100 align-items-end"
          [ngClass] = "{ 
                        'w-100 flex-row justify-content-end' : file && fileCtrl?.errors ,
                        'flex-column' : !file || !fileCtrl?.errors 
                      }">

      <!-- Different Level File Definition Warning -->
      <button *ngIf             = "isDifferentLevelDefined()"
              [matTooltip]      = "dLvlDefHelp | translate : {lvl: getLevelDefinition() }"
              (click)           = "stopPropagation($event)"
              mat-icon-button>
        <mat-icon>{{ dLvlDefIcon | translate }}</mat-icon>
      </button>
      <!-- Info on File Selector -->
      <button *ngIf             = "help | translate"
              [matTooltip]      = "help | translate"
              (click)           = "stopPropagation($event)"
              mat-icon-button>
        <mat-icon>{{ helpIcon | translate }}</mat-icon>
      </button>
      <!-- Change File Icon -->
      <button *ngIf             = "file"
              [matTooltip]      = "changeFileHelp | translate"
              (click)           = "openFileManager($event, fileInput)"
              mat-icon-button>
        {{ changeFileLabel | translate }} 
        <mat-icon *ngIf = "changeFileIcon">
          {{ changeFileIcon | translate }}
        </mat-icon>
      </button>
      <!-- Clear File Selection Icon -->
      <button *ngIf             = "canClear()"
              [matTooltip]      = "removeFileHelp | translate"
              (click)           = "clearFile($event)"
              mat-icon-button>
        {{ removeFileLabel | translate }} 
        <mat-icon *ngIf = "removeFileIcon">
          {{ removeFileIcon | translate }}
        </mat-icon>
      </button>

     <!-- Revert Changes Icon -->
     <button  *ngIf              = "hasChanged()"
              [matTooltip]       = "revertHelp | translate"
              (click)            = "revertChanges($event)"
              mat-icon-button>
      {{ revertLabel | translate }} 
      <mat-icon *ngIf = "revertIcon">
        {{ revertIcon | translate }}
      </mat-icon>
    </button>

      <!-- Send File Icon -->
      <button *ngIf             = "file"
              [disabled]        = "fileCtrl?.errors || !canSend()"
              [matTooltip]      = "sendFileHelp | translate"
              (click)           = "sendFile($event)"
              mat-icon-button>
        {{ sendFileLabel | translate }} 
        <mat-icon *ngIf = "sendFileIcon">
          {{ sendFileIcon | translate }}
        </mat-icon>
      </button>


    </div>
  </div>
  
  <div  *ngIf   = "file && !fileCtrl?.errors"
        class   = "pt-2"
        (click) = "stopPropagation($event)">

    <mat-form-field [appearance]  = "appearance" 
                    class         = "w-100 unpadding"
                    floatLabel    = "always">
      <mat-label >
        {{ 'media.default.description.label' | translate }} 
      </mat-label>
      <textarea [(ngModel)]           = "description"
                matTooltipShowDelay   = "2000"
                [matTooltip]          = "'media.default.description.help' | translate"
                cdkTextareaAutosize
                matInput            ></textarea>
    </mat-form-field>
  </div>
  

  <!-- Check For any error in formCtrl-->
  <mat-error  *ngIf   = "hasErrors( fileCtrl )" 
              (click) = "stopPropagation($event)">
    <p  *ngFor  = "let error of _errors"> 
      <strong> {{ error.text | translate}} </strong> 
    </p>
  </mat-error> 
</mat-form-field>

<!-- TO DO : add progress component -->

<!-- File Detail -->
<!-- 
      <div *ngIf  = "file">
        <div    class   =   "d-flex justify-content-end align-items-end w-100">
          <span   class   =   "limited-text">
              {{ getFileName() }}
          </span>
        </div>
      </div>

-->